





















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import WizardService from '@services/Wizard'
import WizardRoutes from './routes'

settings =
  name: 'VenueCreateWizard'

  resources:
    venue:
      resourceName: 'venue'
      slug: 'suppliers/:supplierId/venues/new'

  vue:
    props: ['options']
    mixins: [WizardService.wizard()]

    components: {
      LoadingIndicator,
    }

    data: ->
      mode: 'CREATE'

    computed:
      member: -> @$store.member
      supplierId: -> @options?.supplierId || @member.supplier.id
      venueData: -> @prime.venue

      wizardRoutes: -> WizardRoutes
      enabledRoutes: -> [@wizardRoutes[0]]
      routeQuery: -> @$route.query

    methods:
      hiClose: ->
        @$router.push({ name: 'VenueListPage' })

      save: ->
        clearTimeout(@time)
        @time = setTimeout(() =>
          @saveItem('prime.venue')
        , 300)

      onSave: (item) ->
        @$router.push({
          name: 'VenueEditPage',
          params: { venueId: item.id },
          query: { step: @wizardRoutes[1].name },
        })

      onSaveError: (item) ->
        @$router.push({
          name: 'VenueEditPage',
          params: { venueId: item.id },
          query: { step: @wizardRoutes[1].name },
        })

    watch:
      steps: ->
        @navToStepName @routeQuery.step, { skipSave: true } if @routeQuery.step?

export default VueOptions.vue settings
